import { INCORPORATION_STAGES, IncorporationStageKey } from './types';

const DELAWARE_DAYS: Record<IncorporationStageKey, number> = {
  order_received: 0,
  documents_review: 2,
  sent_to_registry: 1,
  company_registered: 1,
  documents_available: 1
};

const BAHAMAS_DAYS: Record<IncorporationStageKey, number> = {
  order_received: 0,
  documents_review: 5,
  sent_to_registry: 10,
  company_registered: 7,
  documents_available: 3
};

export const jurisdictionBusinessDays = (jurisdiction: string): Record<IncorporationStageKey, number> => {
  const label = jurisdiction.toLowerCase();
  if (label.includes('delaware')) return DELAWARE_DAYS;
  if (label.includes('bahamas')) return BAHAMAS_DAYS;
  return BAHAMAS_DAYS;
};

export const addBusinessDays = (start: Date, days: number): Date => {
  const date = new Date(start);
  let remaining = days;
  while (remaining > 0) {
    date.setDate(date.getDate() + 1);
    const weekday = date.getDay();
    if (weekday !== 0 && weekday !== 6) remaining -= 1;
  }
  return date;
};

export const estimatedCompletionDate = (
  stages: { key: IncorporationStageKey; status: string }[],
  jurisdiction: string,
  from = new Date()
): Date => {
  const days = jurisdictionBusinessDays(jurisdiction);
  const remaining = stages
    .filter((stage) => stage.status !== 'completed')
    .reduce((total, stage) => total + days[stage.key], 0);
  return addBusinessDays(from, remaining);
};

export const nextStageBusinessDays = (
  stages: { key: IncorporationStageKey; status: string }[],
  jurisdiction: string
): number | null => {
  const currentIndex = stages.findIndex((stage) => stage.status === 'in_progress' || stage.status === 'waiting_customer');
  if (currentIndex < 0) return null;
  const next = INCORPORATION_STAGES[currentIndex + 1];
  if (!next) return null;
  return jurisdictionBusinessDays(jurisdiction)[next];
};
